import { useRef } from 'react';

export function MarkdownEditor({ value, onChange, placeholder, className, minHeight, showCodeBlock }) {
  const textareaRef = useRef(null);

  const wrap = (before, after, fallback) => {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const sel = value.slice(start, end) || fallback;
    const next = value.slice(0, start) + before + sel + after + value.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(start + before.length, start + before.length + sel.length);
    });
  };

  const linePrefix = (prefix) => {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const lineStart = value.lastIndexOf('\n', start - 1) + 1;
    const next = value.slice(0, lineStart) + prefix + value.slice(lineStart);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      const pos = start + prefix.length;
      el.setSelectionRange(pos, pos);
    });
  };

  const tools = [
    { label: 'B',   title: 'Bold',           action: () => wrap('**', '**', 'bold') },
    { label: 'I',   title: 'Italic',          action: () => wrap('*', '*', 'italic') },
    { label: 'H2',  title: 'Heading 2',       action: () => linePrefix('## ') },
    { label: 'H3',  title: 'Heading 3',       action: () => linePrefix('### ') },
    { label: '↗',   title: 'Link',            action: () => wrap('[', '](url)', 'text') },
    { label: '`·`', title: 'Inline code',     action: () => wrap('`', '`', 'code') },
    { label: '—',   title: 'Horizontal rule', action: () => wrap('\n\n---\n\n', '', '') },
    { label: '•',   title: 'Bullet list',     action: () => linePrefix('- ') },
    { label: '1.',  title: 'Numbered list',   action: () => linePrefix('1. ') },
    { label: '>',   title: 'Blockquote',      action: () => linePrefix('> ') },
  ];

  if (showCodeBlock) {
    tools.push({ label: '```', title: 'Code block', action: () => wrap('\n```\n', '\n```\n', 'code') });
  }

  return (
    <div className={`md-editor${className ? ` ${className}` : ''}`}>
      <div className="md-editor__toolbar" role="toolbar" aria-label="Formatting">
        {tools.map(({ label, title, action }) => (
          <button
            key={title}
            type="button"
            className="md-editor__tool"
            title={title}
            aria-label={title}
            onMouseDown={(e) => { e.preventDefault(); action(); }}
          >
            {label}
          </button>
        ))}
      </div>
      <textarea
        ref={textareaRef}
        className="md-editor__textarea"
        value={value}
        onChange={(e) => { onChange(e.target.value); }}
        placeholder={placeholder}
        style={minHeight ? { minHeight } : undefined}
        spellCheck
      />
    </div>
  );
}
